module.exports = __webpack_public_path__ + "img/google-petra-04.744e57d0.jpg";